<template>
    <v-container grid-list-md class="pa-0">
        <v-layout v-for="slotKey in itemKeys" :key="slotKey" wrap>
            <v-flex xs4>
                <slot :name="`label.${slotKey}`" />
            </v-flex>
            <v-flex xs8>
                <slot :name="`inputter.${slotKey}`" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script lang="ts">
import { AppContext } from '../../../store/context';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'InputItem',
})
export default class InputItem extends Vue {
    @Prop({ default: () => [] }) itemKeys: Array<string>;
}
</script>
